<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-button class="float-right" type="line" size="large" @click="showLocalizationsDialog = true" color="primary" icon="edit" ></vs-button>
        <vs-input
          disabled="true"
          class="w-3/4"
          :label-placeholder="`Name`"
          :value="helpers.getPreferredName(category)"
        />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-textarea
          disabled
          :label="`Short Description`"
          :value="helpers.getPreferredFreeDescription(category)"
          height="175"
          style="color: darkgray;"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-textarea
          disabled
          :label="`Long Description`"
          :value="helpers.getPreferredDescription(category)"
          height="175"
          style="color: darkgray;"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <ItoviImageUpload
          :initial-image-url="helpers.getImage(category)"
          :identifier="'hero'"
          :required-aspect-ratio="2.57"
          label-top="18:7 aspect ratio required (i.e. 1080x420)"
          button-text="Hero Image"
          @imageSelected="uploadHeroImage"
        ></ItoviImageUpload>
      </div>
    </div>

    <vs-prompt
      buttons-hidden
      :title="helpers.getPreferredName(category)"
      :active.sync="showLocalizationsDialog">
      <div class="modal-lg">
        <CategoryLocalizationsCard :category="category"
                                     v-on:categoryUpdated="bubbleCategoryUpdated"
        ></CategoryLocalizationsCard>
      </div>
    </vs-prompt>

  </vx-card>
</template>

<script>
  import types from '@/models';
  import {cyclopediaAnalysisCategoryHelpers} from '@/models/helpers'
  import CategoryLocalizationsCard from './CategoryLocalizationsCard';
  import api from '@/http/api';
  import ItoviImageUpload from '@/layouts/components/ItoviImageUpload';

  export default {
    components: {
      CategoryLocalizationsCard,
      ItoviImageUpload,
    },
    data() {
      return {
        showLocalizationsDialog: false,
        helpers: cyclopediaAnalysisCategoryHelpers,
      }
    },
    props: {
      category: {
        type: types.CyclopediaAnalysisCategory,
        required: true,
      },
    },
    methods: {
      async uploadHeroImage(image) {
        console.log('uploadHeroImage()...');
        let images = await api.postCyclopediaAnalysisCategoryHeroImage(this.category, image);
        if (images === null) {
          this.showNotification(false, 'Error uploading image');
        } else {
          this.category.images = images;
          this.showNotification(true, 'Image uploaded');
        }
      },
      bubbleCategoryUpdated(category) {
        this.$emit('categoryUpdated', category);
        this.showLocalizationsDialog = false;
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'
        });
      },
    }
  }
</script>

<style lang="scss" scoped>

  .center-container {
    position: relative;
  }
  .upload-button-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .product-image {
    object-fit: scale-down;
    object-position: 50% 50%;
    width: 100%;
    max-height: 150px;
  }
</style>
